<template>
  <div class="form-base">
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          label="Наименование"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <AddressStructuredField
          :value="v.address.$model"
          @change="v.address.$model = $event"
          :v="v.address"
          label="Адрес (место нахождения) организации"
        />
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          label="ИНН организации"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <div class="form-base__title">
          ФИО лица, имеющего право без доверенности действовать от имени
          иностранного юридического лица
        </div>
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model="v.assigneeLastName.$model"
          :errorMessages="getValidationErrorText(v.assigneeLastName)"
          label="Фамилия"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.assigneeName.$model"
          :errorMessages="getValidationErrorText(v.assigneeName)"
          label="Имя"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.assigneePatronymic.$model"
          :errorMessages="getValidationErrorText(v.assigneePatronymic)"
          label="Отчество (при наличии)"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <TrusteeView
          :v="v.trustee"
          :label="'Сведения о представителе иностранного юридического лица'"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';
import deepmerge from 'deepmerge';
import { maxLength, required } from 'vuelidate/lib/validators';

import TrusteeView, {
  trusteeModel,
  trusteeValidate,
} from '@/components/services/elements/TrusteeView';
import {
  getValidationErrorText,
  MAX_LENGTH,
  EMOJI,
  PERSON_NAME,
} from '@/utils/validate';
import AddressStructuredField, {
  addressValidate,
} from '@/components/base/AddressStructuredField';

export const foreignOrganizationModel = {
  name: '',
  address: '',
  inn: '',
  assigneeLastName: '',
  assigneeName: '',
  assigneePatronymic: '',
  trustee: cloneDeep(trusteeModel),
};

export const getForeignOrganizationValidation = (foreignOrganization) => ({
  name: {
    required,
    maxLength: maxLength(1000),
    EMOJI,
  },
  address: {
    required,
    ...addressValidate(),
  },
  inn: {
    required,
    maxLength: maxLength(10),
    EMOJI,
  },
  assigneeLastName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  assigneeName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  assigneePatronymic: {
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  trustee: deepmerge(trusteeValidate(foreignOrganization.trustee), {
    email: {
      required,
    },
    phone: {
      required,
    },
  }),
});

export default {
  name: 'ForeignOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: { TrusteeView, AddressStructuredField },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>
